module.exports = __webpack_public_path__ + "img/28.c24a0e34.png";